// https://vuex.vuejs.org/en/getters.html


export default {
  pendingMoments :(state) => state.listMoments.filter(item => item.status === 'pending')
};
